/* Extra copy for each service-detail page — audience, engagement steps, and
   distinct benefits (separate from the existing detailed `scope` checklist).
   Sourced from the existing service scope + Turkish operational vocabulary;
   no invented statistics, prices, partnerships or customer claims. */

export const SERVICE_EXTRAS = {
  "pazaryeri-kurulum-yonetimi": {
    audience: [
      "Pazaryerlerinde satmak isteyen ancak süreci nereden başlatacağını bilmeyen işyerleri",
      "Mağaza başvurusundan ürün girişine kadar operasyonel yük yaşayan işyerleri",
      "Birden fazla pazaryerinde eş zamanlı satış yapmak isteyen işyerleri",
      "Sipariş operasyonunu takip edecek iç ekip ayıramayan işyerleri",
    ],
    steps: [
      { title: "Analiz", desc: "Ürün yapınız ve satış kanalı ihtiyacınız incelenir." },
      { title: "Kurulum", desc: "Mağaza başvurusu ve ürün girişleri hazırlanır." },
      { title: "Yayın", desc: "Mağaza pazaryerlerinde satışa açılır." },
      { title: "Yönetim", desc: "Sipariş, kampanya ve performans süreçleri düzenli olarak takip edilir." },
    ],
    benefits: [
      "Pazaryeri süreçlerinizi tek noktadan yönetim",
      "Manuel iş yükünün azalması",
      "Kampanya ve satış fırsatlarının düzenli takibi",
      "Sipariş operasyonunda tutarlılık",
    ],
  },
  "uye-isyerine-ozel-siparis-sistemi": {
    audience: [
      "Kendi internet sitesi ve mobil uygulamasıyla sipariş almak isteyen işyerleri",
      "Pazaryerlerine ek olarak kendi satış kanalını kurmak isteyen işyerleri",
      "Müşteri sadakati oluşturmak isteyen işyerleri",
      "Sipariş operasyonunu tek panelden yönetmek isteyen işyerleri",
    ],
    steps: [
      { title: "Analiz", desc: "Kurumsal kimlik ve operasyon ihtiyacınız değerlendirilir." },
      { title: "Kurulum", desc: "Web sipariş sistemi ve mobil uygulama işyerinize özel hazırlanır." },
      { title: "Yayın", desc: "Uygulama App Store ve Google Play'de yayımlanır." },
      { title: "Yönetim", desc: "Ürün, sipariş ve müşteri yönetimi tek panelden takip edilir." },
    ],
    benefits: [
      "Kendi markanız üzerinden doğrudan sipariş alma",
      "Müşteri verilerinizin kendi elinizde kalması",
      "Pazaryeri komisyon yapısına alternatif satış kanalı",
      "Tek panelden ürün, sipariş ve teslimat yönetimi",
    ],
  },
  "kurye-cozumu": {
    audience: [
      "Kendi kuryesi bulunmayan işyerleri",
      "Teslimat kapasitesini geçici olarak artırmak isteyen işyerleri",
      "Farklı satış kanallarından gelen siparişleri tek noktadan teslim etmek isteyen işyerleri",
      "Yoğun saatlerde ek kurye ihtiyacı olan işyerleri",
    ],
    steps: [
      { title: "Analiz", desc: "Konumunuz, sipariş yoğunluğunuz ve teslimat mesafeniz incelenir." },
      { title: "Kurulum", desc: "Kurye yönlendirme sisteminiz sipariş kanallarınıza bağlanır." },
      { title: "Yayın", desc: "Kurye operasyonu belirlenen saatlerde başlar." },
      { title: "Yönetim", desc: "Teslimatlar harita üzerinden takip edilir ve raporlanır." },
    ],
    benefits: [
      "Kurye yokluğunda sipariş kaybının önlenmesi",
      "Farklı satış kanallarındaki siparişlere tek çözüm",
      "Harita üzerinden canlı takip",
      "Operasyon yoğunluğuna göre esnek planlama",
    ],
  },
  "fiyat-ve-stok-entegrasyonu": {
    audience: [
      "Birden fazla satış kanalında ürün satan işyerleri",
      "Fiyat ve stoklarını manuel güncelleyen ve iş yükü yaşayan işyerleri",
      "Stokta olmayan ürünlerin siparişini engellemek isteyen işyerleri",
      "Farklı kanallarda tutarlı bilgi akışı isteyen işyerleri",
    ],
    steps: [
      { title: "Analiz", desc: "Kasa veya stok sisteminizin teknik uygunluğu incelenir." },
      { title: "Kurulum", desc: "Sistem, satış kanallarınızla eşleştirilir." },
      { title: "Yayın", desc: "Fiyat ve stok akışı canlıya alınır." },
      { title: "Yönetim", desc: "Akış düzenli olarak izlenir ve gerektiğinde ayarlanır." },
    ],
    benefits: [
      "Fiyatların satış kanallarında güncel kalması",
      "Stokta olmayan ürün siparişlerinin azalması",
      "Manuel iş yükünün düşmesi",
      "Ürün takibinin kolaylaşması",
    ],
  },
  "urun-ve-menu-yonetimi": {
    audience: [
      "Ürün veya menü listesi yüksek olan işyerleri",
      "Satış kanallarında ürün açıklama ve görsel kalitesini artırmak isteyen işyerleri",
      "Yeni pazaryerine açılırken katalog hazırlığı yükü yaşayan işyerleri",
      "Ürün kategorileri, seçenekleri ve gramaj bilgileri düzenli tutulmayan işyerleri",
    ],
    steps: [
      { title: "Analiz", desc: "Ürün veya menü listesi kanal bazında değerlendirilir." },
      { title: "Kurulum", desc: "Ürün bilgileri, seçenekler ve görseller hazırlanır." },
      { title: "Yayın", desc: "Katalog satış kanallarına listelenir." },
      { title: "Yönetim", desc: "Ürün değişiklikleri ve yeni girişler düzenli olarak yönetilir." },
    ],
    benefits: [
      "Arama motoru dostu ürün adları ve açıklamaları",
      "Kanal bazında uygun listeleme",
      "Ürün görsellerinde tutarlı standart",
      "Yeni ürün eklemede hızlı süreç",
    ],
  },
  "dijital-operasyon-yonetimi": {
    audience: [
      "Dijital satış operasyonunu takip edecek iç ekip ayıramayan işyerleri",
      "Kampanya, sipariş, iade ve fatura süreçlerinde destek isteyen işyerleri",
      "Mağaza performansını düzenli değerlendirmek isteyen işyerleri",
      "Yeni satış kanallarına açılmayı planlayan işyerleri",
    ],
    steps: [
      { title: "Analiz", desc: "Mevcut satış kanallarınız ve operasyon ihtiyacınız değerlendirilir." },
      { title: "Kurulum", desc: "Operasyon planı ve takip süreci belirlenir." },
      { title: "Yayın", desc: "Süreçler düzenli takibe alınır." },
      { title: "Yönetim", desc: "Sipariş, kampanya, iade ve performans süreçleri sürekli izlenir." },
    ],
    benefits: [
      "Sürekli iletişim halinde operasyon ekibi",
      "Kampanya ve sipariş süreçlerinde tutarlılık",
      "Mağaza performansının düzenli değerlendirilmesi",
      "Yeni satış kanalı planlamasında destek",
    ],
  },
};
